import { z } from "zod";

// Paridade com as diretivas dc* do template legado: texto, tipo e seLiberado
// são dc-not-empty; dataValidade só tem dc-input (opcional).
export const mensageriaSchema = z.object({
  idMensageria: z.number().optional(),
  texto: z.string().min(1, "Informe o texto.").max(255, "Máximo de 255 caracteres."),
  tipo: z.enum(["A", "E", "N"], { message: "Selecione o tipo." }),
  dataValidade: z.string().optional(),
  seLiberado: z.enum(["S", "N"], { message: "Selecione se está liberado." }),
});

export type MensageriaFormValues = z.infer<typeof mensageriaSchema>;
